import { useState } from "react";
import { Building2, ChevronLeft, ChevronRight, ExternalLink, FileText, Leaf, Recycle } from "lucide-react";

const catalogs = [
  {
    id: "lisansli-atik",
    icon: Recycle,
    title: "Lisanslı Atık Toplama Firmaları",
    description: "Lisanslı atık toplama firmalarına yönelik ATIKSOFT çözümlerini inceleyin.",
    file: "/documents/lisansli-atik-toplama.pdf",
    pages: 12,
  },
  {
    id: "sifir-atik",
    icon: Leaf,
    title: "İklim Değişikliği ve Sıfır Atık Müdürlüğü",
    description: "İklim Değişikliği ve Sıfır Atık Müdürlüğüne yönelik çözümlerimizi Sıfır Atık kataloğunda keşfedin.",
    file: "/documents/sifir-atik.pdf",
    pages: 12,
  },
  {
    id: "temizlik-isleri",
    icon: Building2,
    title: "Temizlik İşleri Müdürlüğü",
    description: "Temizlik İşleri Müdürlüğüne yönelik saha ve operasyon yönetimi çözümlerimizi keşfedin.",
    file: "/documents/temizlik-isleri.pdf",
    pages: 16,
  },
];

export default function AboutCatalogs() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [pages, setPages] = useState([1, 1, 1]);
  const catalog = catalogs[activeIndex];
  const page = pages[activeIndex];

  const changePage = (direction) => {
    setPages((current) => current.map((value, index) =>
      index === activeIndex
        ? Math.max(1, Math.min(catalog.pages, value + direction))
        : value,
    ));
  };

  return (
    <section className="about-catalogs" aria-labelledby="about-catalogs-title">
      <div className="deposit-catalog logistics-catalog container">
        <div className="deposit-catalog-heading">
          <div>
            <p className="section-kicker">04 / TANITIM KATALOGLARI</p>
            <h2 id="about-catalogs-title">Kurumunuza özel <span>çözümlerimizi keşfedin.</span></h2>
          </div>
          <p>İlgilendiğiniz kataloğu seçin, oklarla sayfaları inceleyin veya PDF olarak açın.</p>
        </div>
        <div className="about-catalog-options" role="group" aria-label="Katalog seçimi">
          {catalogs.map((item, index) => (
            <button
              key={item.id}
              type="button"
              aria-pressed={index === activeIndex}
              aria-controls="about-catalog-content"
              onClick={() => setActiveIndex(index)}
            >
              <span className="catalog-topic-icon">
                <item.icon size={26} strokeWidth={1.5} aria-hidden="true" />
              </span>
              <span>{item.title}<small>{item.pages} sayfa · PDF katalog</small></span>
            </button>
          ))}
        </div>
        <div id="about-catalog-content" className="about-catalog-content">
          <div className="about-catalog-description" aria-live="polite">
            <h3>{catalog.title}</h3>
            <p>{catalog.description}</p>
          </div>
          <div
            className="catalog-reader"
            onKeyDown={(event) => {
              if (event.key === "ArrowLeft" || event.key === "ArrowRight") {
                event.preventDefault();
                changePage(event.key === "ArrowRight" ? 1 : -1);
              }
            }}
          >
            <button className="catalog-control" type="button" onClick={() => changePage(-1)}
              disabled={page === 1} aria-label="Önceki katalog sayfası" aria-controls="about-catalog-page">
              <ChevronLeft size={24} />
            </button>
            <div className="catalog-page" id="about-catalog-page" tabIndex={0}>
              <img
                key={`${catalog.id}-${page}`}
                src={`/${catalog.id}-katalogu/page-${String(page).padStart(2, "0")}.jpg`}
                alt={`${catalog.title} kataloğu, ${page}. sayfa`}
                width={1800}
                height={1273}
                loading="lazy"
              />
            </div>
            <button className="catalog-control" type="button" onClick={() => changePage(1)}
              disabled={page === catalog.pages} aria-label="Sonraki katalog sayfası" aria-controls="about-catalog-page">
              <ChevronRight size={24} />
            </button>
          </div>
          <div className="logistics-catalog-footer">
            <p className="catalog-page-number" aria-live="polite" aria-atomic="true">Sayfa {page} / {catalog.pages}</p>
            <a href={encodeURI(catalog.file)} target="_blank" rel="noreferrer">
              <FileText size={16} /> PDF’yi aç <ExternalLink size={14} />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
